// const SERVER_URL = "https://tennis-challenge.net"
// const LOCAL_URL = process.env.REACT_APP_API_URL;

export const apiUrl = process.env.REACT_APP_API_URL;

export const scrollTriggerHeight = 100;

export const isDevelopment = process.env.NODE_ENV === 'development';
